const config = {

	BASE: '/',

	$body: document.body,
	$view: document.querySelector('#js-page'),

	width: window.innerWidth,
	height: window.innerHeight,

	isMobile: false

}

export default config


/** WEBPACK FOOTER **
 ** ./pjax/config.js
 **/